import {branch as branchHOC, renderNothing} from 'recompose'

import compose from 'lodash/flowRight'
import * as React from 'react'

import {getBuild} from '../../../../../selectors'
import {restApi} from '../../../../../services/rest'
import type {BuildId} from '../../../../../types'
import {useSequenceLoaderReadyHandler} from '../../../../common/SequenceLoader/SequenceLoader.hooks'

import BuildSnippet from './BuildSnippet/BuildSnippet'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  buildId: BuildId
  seqKey?: string
}

function BuildSnippetsContainer({buildId}: Props) {
  const buildState = useAppSelector(state => getBuild(state, buildId)?.state)
  const {buildSnippetList, refetch} = restApi.endpoints.getBuildSnippets.useQuery(buildId, {
    selectFromResult: ({data}) => ({buildSnippetList: data}),
  })
  useSequenceLoaderReadyHandler(buildSnippetList != null)
  React.useEffect(() => {
    refetch()
  }, [buildState, refetch])

  if (!buildSnippetList?.map) {
    return null
  }

  return buildSnippetList
    .filter(snippet => snippet.id !== 'coverage') // TODO remove when server-sided
    .map(snippet => <BuildSnippet buildId={buildId} snippet={snippet} key={snippet.id} />)
}

export default compose(
  branchHOC(({buildId}: Props) => !buildId, renderNothing),
  React.memo,
)(BuildSnippetsContainer)
